import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBox,
  faBarcode,
  faIndianRupeeSign,
  faBoxesStacked,
  faPlus,
  faEdit,
  faTrash,
  faPercentage,
  faImage,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";
import { configData } from "../config";
import "./classes/ManageItems.css";
import Pagination from "./Pagination";
import TextField from "@mui/material/TextField";

const API_BASE = configData.APP_URL;

const ManageItems = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [editSubmitting, setEditSubmitting] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const filteredItems = items.filter(item =>
  item.item_name?.toLowerCase().includes(searchValue.toLowerCase())
);

  const itemsPerPage = 15;
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0,0);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

useEffect(() => {
  setCurrentPage(1);
},[searchValue]);
  // Create form state (left panel)
  const [formData, setFormData] = useState({
    name: "",
    barcode: "",
    hsn_code: "",
    retail_price: "",
    wholesale_price: "",
    stock: "",
    tax_one: "",
    tax_two: "",
    purchase_amount: "",
    unit: "Nos",
    product_image: null,
  });

  // Edit modal state
  const [editingId, setEditingId] = useState(null);
  const [editFormData, setEditFormData] = useState({
    name: "",
    barcode: "",
    hsn_code: "",
    retail_price: "",
    wholesale_price: "",
    stock: "",
    tax_one: "",
    tax_two: "",
    purchase_amount: "",
    unit: "",
    product_image: null,
  });
  const [modal, setModal] = useState(false);

  const fetchItems = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_BASE}items/lists`);
      const data = await res.json();

      let list = [];
      if (Array.isArray(data)) {
        list = data;
      } else if (data?.data && Array.isArray(data.data)) {
        list = data.data;
      } else if (data?.items && Array.isArray(data.items)) {
        list = data.items;
      }

      // setItems(list);
      setItems([...list].sort((a, b) => b.id - a.id));
    } catch (error) {
      console.error("Error fetching items:", error);
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateItem = (data) => {
    if (!data.name?.trim()) {
      alert("Item name is required");
      return false;
    }

    if (!data.barcode?.trim()) {
      alert("Barcode is required");
      return false;
    }

  // const barcode = data.barcode.toString().trim();

  // const isDuplicate = items.some(
  //   (item) =>
  //     item.id !== editingId &&
  //     item.barcode?.toString().trim() === barcode
  // );

  // if (isDuplicate) {
  //   alert("Barcode already exists");
  //   return false;
  // }

    const barcode = data.barcode?.toString().trim();

    const isDuplicate =
      barcode &&
      items.some(
        (item) =>
          item.id !== editingId &&
          item.barcode?.toString().trim() === barcode
      );

    if (isDuplicate) {
      alert("Barcode already exists");
      return false;
    }

    // if (data.hsn_code?.length > 10) {
    //   alert("HSN code must be at most 10 characters");
    //   return;
    // }

    if (!data.retail_price?.toString().trim()) {
      alert("Retail Price is required");
      return false;
    }

    if (!data.wholesale_price?.toString().trim()) {
      alert("Wholesale Price is required");
      return false;
    }

    if (!data.stock?.toString().trim()) {
      alert("Stock is required");
      return false;
    }

    if (!data.tax_one?.toString().trim()) {
      alert("SGST is required");
      return false;
    }

    if (!data.tax_two?.toString().trim()) {
      alert("CGST is required");
      return false;
    }

    if (!data.purchase_amount?.toString().trim()) {
      alert("Purchase Amount is required");
      return false;
    }

    const numericRetailPrice = parseFloat(data.retail_price);
    const numericWholeSalePrice = parseFloat(data.wholesale_price);
    const numericStock = parseInt(data.stock, 10);
    const numericTaxOne = parseFloat(data.tax_one);
    const numericTaxTwo = parseFloat(data.tax_two);
    const numericPurchaseAmount = parseFloat(data.purchase_amount);

    if (
      Number.isNaN(numericRetailPrice) || numericRetailPrice < 0 ||
      Number.isNaN(numericWholeSalePrice) || numericWholeSalePrice < 0
    ) {
      alert("Price must be a valid number");
      return false;
    }

    if (Number.isNaN(numericStock) || numericStock < 0) {
      alert("Stock must be a valid number");
      return false;
    }

    if (
      Number.isNaN(numericTaxOne) || numericTaxOne < 0 ||
      Number.isNaN(numericTaxTwo) || numericTaxTwo < 0
    ) {
      alert("SGST and CGST must be valid whole numbers");
      return false;
    }

    if (Number.isNaN(numericPurchaseAmount) || numericPurchaseAmount < 0) {
      alert("Purchase Amount must be a valid number and cannot be negative");
      return false;
    }

    return true; 
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!validateItem(formData)) return;

  setSubmitting(true);

  try {
    const postData = new FormData();

    if (formData.product_image) {
      postData.append("product_image", formData.product_image);
    }

    // Prepare the rest of the form data without the file
    const { product_image, ...rest } = formData;

    // Convert numeric fields to numbers
    const restWithNumbers = {
      ...rest,
      retail_price: parseFloat(rest.retail_price),
      wholesale_price: parseFloat(rest.wholesale_price),
      stock: parseInt(rest.stock, 10),
      tax_one: parseFloat(rest.tax_one),
      tax_two: parseFloat(rest.tax_two),
      purchase_amount: parseFloat(rest.purchase_amount),
    };

    // postData.append("formData", JSON.stringify(restWithNumbers));
    Object.entries(restWithNumbers).forEach(([key, value]) => {
      postData.append(key, value);
    });

    const res = await fetch(`${API_BASE}items/creates`, {
      method: "POST",
      body: postData, 
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Failed to create item");

    alert("Item created successfully");

    setFormData({
      name: "",
      barcode: "",
      hsn_code: "",
      retail_price: "",
      wholesale_price: "",
      stock: "",
      tax_one: "",
      tax_two: "",
      purchase_amount: "",
      unit: "Nos",
      product_image: null,
    });

    fetchItems();
  } catch (error) {
    console.error("Error saving item:", error);
    alert(error.message);
  } finally {
    setSubmitting(false);
  }
};

  const handleEditSubmit = async (e) => {
    e.preventDefault();

    if (!validateItem(editFormData)) return;

    setEditSubmitting(true);

    try {
      const postData = new FormData();

      if (editFormData.product_image instanceof File) {
        postData.append("product_image", editFormData.product_image);
      } else if (editFormData.product_image === null) {
        postData.append("remove_image", "1"); 
      }

      // Prepare the rest of the form data
      const { product_image, ...rest } = editFormData;

      // Convert numeric fields to numbers
      const restWithNumbers = {
        ...rest,
        retail_price: parseFloat(rest.retail_price),
        wholesale_price: parseFloat(rest.wholesale_price),
        stock: parseInt(rest.stock, 10),
        tax_one: parseFloat(rest.tax_one),
        tax_two: parseFloat(rest.tax_two),
        purchase_amount: parseFloat(rest.purchase_amount),
      };

      // postData.append("formData", JSON.stringify(restWithNumbers));
      Object.entries(restWithNumbers).forEach(([key, value]) => {
        postData.append(key, value);
      });

      const res = await fetch(`${API_BASE}items/updates?item_id=${editingId}`, {
        method: "POST",
        body: postData,
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to update item");

      alert("Item updated successfully");

      setEditingId(null);
      setModal(false);
      setEditFormData({
        name: "",
        barcode: "",
        hsn_code: "",
        retail_price: "",
        wholesale_price: "",
        stock: "",
        tax_one: "",
        tax_two: "",
        purchase_amount: "",
        unit: "",
        product_image: null,
      });

      fetchItems();
    } catch (error) {
      console.error("Error updating item:", error);
      alert(error.message);
    } finally {
      setEditSubmitting(false);
    }
  };

  const handleEdit = (item) => {
    const id = item.id ?? item.item_id;
    setEditFormData({
      name: item.name ?? item.item_name ?? "",
      barcode: item.barcode ?? "",
      hsn_code: item.hsn_code ?? "",
      retail_price:
        item.retail_price != null ? String(item.retail_price) : "",
      wholesale_price:
        item.wholesale_price != null ? String(item.wholesale_price) : "",
      stock:
        item.stock != null
          ? String(item.stock)
          : item.quantity != null
          ? String(item.quantity)
          : "",
      tax_one:
        item.tax_one != null ? String(item.tax_one) : "",
      tax_two:
        item.tax_two != null ? String(item.tax_two) : "",
      purchase_amount:
        item.purchase_amount != null ? String(item.purchase_amount) : "",
      unit:  item.unit ?? "Nos",
      product_image: 
       item.product_image != null ? item.product_image : ""
    });
    setEditingId(id);
    setModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this item?")) return;

    try {
      const res = await fetch(`${API_BASE}items/deletes?item_id=${id}`, {
        method: "DELETE",
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Failed to delete item");
      alert("Item deleted successfully");

      fetchItems();
    } catch (error) {
      console.error("Error deleting item:", error);
      alert(error.message);
    }
  };

  const handleCancelEdit = () => {
    setEditingId(null);
    setModal(false);
    setEditFormData({
      name: "",
      barcode: "",
      hsn_code: "",
      retail_price: "",
      wholesale_price: "",
      stock: "",
      tax_one: "",
      tax_two: "",
      purchase_amount: "",
      unit: "Nos"
    });
  };

  return (
    <div className="manage-items-main">
      <Helmet>
        <title>Manage Items</title>
      </Helmet>
      <div className="main">
        <div className="left-container">
          <span className="create-user-title">
            <FontAwesomeIcon icon={faBox} />
            <h3>Item Management</h3>
          </span>

          <div className="create-user-container">
            <h2>Add New Item</h2>

            <form onSubmit={handleSubmit}>
              <div className="login-form-field">
                <label htmlFor="name">Item Name *</label>
                <div className="login-input-container">
                  <span className="login-input-icon-container">
                    <FontAwesomeIcon icon={faBox} />
                  </span>
                  <input
                    id="name"
                    type="text"
                    name="name"
                    placeholder="Item name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="login-form-field">
                <label htmlFor="barcode">Barcode *</label>
                <div className="login-input-container">
                  <span className="login-input-icon-container">
                    <FontAwesomeIcon icon={faBarcode} />
                  </span>
                  <input
                    id="barcode"
                    type="text"
                    name="barcode"
                    placeholder="Barcode"
                    value={formData.barcode}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="login-form-field">
                <label htmlFor="hsn_code">HSN Code</label>
                <div className="login-input-container">
                  <span className="login-input-icon-container">
                    <FontAwesomeIcon icon={faSearch} />
                  </span>
                  <input
                    id="hsn_code"
                    type="text"
                    name="hsn_code"
                    placeholder="HSN Code"
                    value={formData.hsn_code}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="login-form-field">
                <label htmlFor="retail_price">Retail Price *</label>
                <div className="login-input-container">
                  <span className="login-input-icon-container">
                    <FontAwesomeIcon icon={faIndianRupeeSign} />
                  </span>
                  <input
                    id="retail_price"
                    type="number"
                    step="0.01"
                    min="0"
                    name="retail_price"
                    placeholder="Retail price"
                    value={formData.retail_price}
                    onChange={handleChange}
                    onWheel={(e) => {
                      e.preventDefault();
                      e.currentTarget.blur(); 
                    }}
                  />
                </div>
              </div>

              <div className="login-form-field">
                <label htmlFor="wholesale_price">Wholesale Price *</label>
                <div className="login-input-container">
                  <span className="login-input-icon-container">
                    <FontAwesomeIcon icon={faIndianRupeeSign} />
                  </span>
                  <input
                    id="wholesale_price"
                    type="number"
                    step="0.01"
                    min="0"
                    name="wholesale_price"
                    placeholder="Wholesale price"
                    value={formData.wholesale_price}
                    onChange={handleChange}
                    onWheel={(e) => {
                      e.preventDefault();
                      e.currentTarget.blur(); 
                    }}
                  />
                </div>
              </div>

              <div className="login-form-field">
                <label htmlFor="stock">Stock *</label>
                <div className="login-input-container">
                  <span className="login-input-icon-container">
                    <FontAwesomeIcon icon={faBoxesStacked} />
                  </span>
                  <input
                    id="stock"
                    type="number"
                    min="0"
                    name="stock"
                    placeholder="Stock quantity"
                    value={formData.stock}
                    onChange={handleChange}
                    onWheel={(e) => {
                      e.preventDefault();
                      e.currentTarget.blur(); 
                    }}
                  />
                </div>
              </div>

              <div className="login-form-field">
                <label htmlFor="tax_one">SGST *</label>
                <div className="login-input-container">
                  <span className="login-input-icon-container">
                    <FontAwesomeIcon icon={faPercentage} />
                  </span>
                  <input
                    id="tax_one"
                    type="number"
                    step="0.01"
                    min="0"
                    name="tax_one"
                    placeholder="SGST"
                    value={formData.tax_one}
                    onChange={handleChange}
                    onWheel={(e) => {
                      e.preventDefault();
                      e.currentTarget.blur(); 
                    }}
                  />
                </div>
              </div>

              <div className="login-form-field">
                <label htmlFor="tax_two">CGST *</label>
                <div className="login-input-container">
                  <span className="login-input-icon-container">
                    <FontAwesomeIcon icon={faPercentage} />
                  </span>
                  <input
                    id="tax_two"
                    type="number"
                    step="0.01"
                    min="0"
                    name="tax_two"
                    placeholder="CGST"
                    value={formData.tax_two}
                    onChange={handleChange}
                    onWheel={(e) => {
                      e.preventDefault();
                      e.currentTarget.blur(); 
                    }}
                  />
                </div>
              </div>

              <div className="login-form-field">
                <label htmlFor="purchase_amount">Purchase Amount *</label>
                <div className="login-input-container">
                  <span className="login-input-icon-container">
                    <FontAwesomeIcon icon={faIndianRupeeSign} />
                  </span>
                  <input
                    id="purchase_amount"
                    type="number"
                    step="0.01"
                    min="0"
                    name="purchase_amount"
                    placeholder="Purchase amount"
                    value={formData.purchase_amount}
                    onChange={handleChange}
                    onWheel={(e) => {
                      e.preventDefault();
                      e.currentTarget.blur(); 
                    }}
                  />
                </div>
              </div>

              <div className="login-form-field">
                <label htmlFor="unit">Unit</label>
                <div className="login-input-container">
                  <select
                    id="unit"
                    name="unit"
                    value={formData.unit}
                    onChange={handleChange}
                    style={{padding: "0.75rem 0.9rem 0.75rem 0.75rem"}}
                  >
                    <option value="Nos">Nos</option>
                    <option value="mtr">mtr</option>
                    <option value="kg">kg</option>
                    <option value="ltr">ltr</option>
                    <option value="ft">ft</option>
                    <option value="in">in</option>
                    <option value="len">len</option>
                    <option value="box">box</option>
                    <option value="set">set</option>
                  </select>
                </div>
              </div>

              <div className="login-form-field">
                <label>Product Image</label>
                <div className="login-input-container login-input-image-container">
                  {formData.product_image ? (
                    <div style={{ marginTop: "10px" }} className="product-image-container">
                      <img
                        src={URL.createObjectURL(formData.product_image)}
                        alt="Preview"
                        style={{ width: 100, height: 100, objectFit: "cover" }}
                      />
                      <button
                        type="button"
                        onClick={() => setFormData((prev) => ({ ...prev, product_image: null }))}
                      >
                        Remove
                      </button>
                    </div>
                  ) : (<>
                  <span className="login-input-icon-container">
                    <FontAwesomeIcon icon={faImage} />
                  </span>
                  <input
                    type="file"
                    accept=".jpg,.jpeg,.png"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (!file) return;

                      const validTypes = ["image/jpeg", "image/png", "image/jpg"];
                      if (!validTypes.includes(file.type)) {
                        alert("Invalid file type! Only JPG, JPEG, PNG allowed.");
                        return;
                      }

                      setFormData((prev) => ({ ...prev, product_image: file }));
                    }}
                  />
                  </>)}
                </div>
              </div>
              <div className="form-actions">
                <button
                  type="submit"
                  className="login-form-submit"
                  disabled={submitting}
                >
                  <FontAwesomeIcon icon={faPlus} />
                  {submitting ? " Saving..." : " Add Item"}
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className="center left-center">
          <div className="items-container">
            <div className="items-page-search">
              <h3>Existing Items</h3>
              <div className="pos-field pos-field-wide">
                <label>Product</label>
                <TextField
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  placeholder="Search product"
                  size="small"
                  fullWidth
                />
              </div>
            </div>
            {loading ? (
              <p className="no-data-message">Loading items...</p>
            ) : items.length === 0 ? (
              <p className="no-data-message">No items yet. Add one using the form.</p>
            ) : filteredItems.length === 0 ? (
              <p className="no-data-message">No items found.</p>
            ) : (
			        <>
                <div className="desktop-table">
                <table className="item-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Barcode</th>
                      <th>Retail Price</th>
                      <th>Wholesale Price</th>
                      <th>Stock</th>
                      <th>Tax</th>
                      <th>Purchase Price</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.map((item) => {
                      const id = item.id ?? item.item_id;
                      const name = item.name ?? item.item_name ?? "—";
                      const barcode = item.barcode ?? "—";
                      const hsn_code = item.hsn_code ?? "—";
                      const unit = item.unit ?? "—";
                      const retailPrice =
                        typeof item.retail_price === "number"
                          ? `₹${item.retail_price.toFixed(2)}`
                          : item.retail_price
                          ? `₹${Number(item.retail_price).toFixed(2)}`
                          : "—";
                      const wholesalePrice =
                        typeof item.wholesale_price === "number"
                          ? `₹${item.wholesale_price.toFixed(2)}`
                          : item.wholesale_price
                          ? `₹${Number(item.wholesale_price).toFixed(2)}`
                          : "—";
                      const stock =
                        item.stock != null
                          ? item.stock
                          : item.quantity != null
                          ? item.quantity
                          : "—";
                      const SGST =
                        typeof item.tax_one === "number"
                          ? `${item.tax_one.toFixed(2)}%`
                          : item.tax_one
                          ? `${Number(item.tax_one).toFixed(2)}%`
                          : "—";
                      const CGST =
                        typeof item.tax_two === "number"
                          ? `${item.tax_two.toFixed(2)}%`
                          : item.tax_two
                          ? `${Number(item.tax_two).toFixed(2)}%`
                          : "—";
                      const purchaseAmount =
                        typeof item.purchase_amount === "number"
                          ? `₹${item.purchase_amount.toFixed(2)}`
                          : item.purchase_amount
                          ? `₹${Number(item.purchase_amount).toFixed(2)}`
                          : "—";

                      return (
                        <tr key={id}>
                          <td>{name}</td>
                          <td>{barcode}</td>
                          <td>{retailPrice}</td>
                          <td>{wholesalePrice}</td>
                          <td>{stock}</td>
                          <td>
                            SGST: {SGST}<br />
                            CGST: {CGST}
                          </td>
                          <td>{purchaseAmount}</td>
                          <td className="icon-cell manage-items-icon-cell">
                            <span
                              className="action-icon edit"
                              onClick={() => handleEdit(item)}
                              title="Edit"
                            >
                              <FontAwesomeIcon icon={faEdit} />
                            </span>
                            <span
                              className="action-icon delete"
                              onClick={() => handleDelete(id)}
                              title="Delete"
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <Pagination
                  currentPage={currentPage}
                  totalItems={filteredItems.length}
                  itemsPerPage={itemsPerPage}
                  onPageChange={handlePageChange}
                />
                </div>
                <div className="mobile-table">
                  {currentItems.map((item) => {
                    const id = item.id ?? item.item_id;
                    const name = item.name ?? item.item_name ?? "—";
                    const barcode = item.barcode ?? "—";
                    const hsn_code = item.hsn_code ?? "—";
                    const unit = item.unit ?? "—";
                    const retailPrice =
                      typeof item.retail_price === "number"
                        ? `₹${item.retail_price.toFixed(2)}`
                        : item.retail_price
                        ? `₹${Number(item.retail_price).toFixed(2)}`
                        : "—";
                    const wholesalePrice =
                      typeof item.wholesale_price === "number"
                        ? `₹${item.wholesale_price.toFixed(2)}`
                        : item.wholesale_price
                        ? `₹${Number(item.wholesale_price).toFixed(2)}`
                        : "—";
                    const stock =
                      item.stock != null
                        ? item.stock
                        : "—";
                    const SGST =
                      typeof item.tax_one === "number"
                        ? `${item.tax_one.toFixed(2)}%`
                        : item.tax_one
                        ? `${Number(item.tax_one).toFixed(2)}%`
                        : "—";
                    const CGST =
                      typeof item.tax_two === "number"
                        ? `${item.tax_two.toFixed(2)}%`
                        : item.tax_two
                        ? `${Number(item.tax_two).toFixed(2)}%`
                        : "—";
                    const purchaseAmount =
                      typeof item.purchase_amount === "number"
                        ? `₹${item.purchase_amount.toFixed(2)}`
                        : item.purchase_amount
                        ? `₹${Number(item.purchase_amount).toFixed(2)}`
                        : "—";

                    return (
                      <div key={id} className="items-card">
                        <div className="user-card-main">
                          <span className="user-card-name">{name}</span>
                          <span className="user-card-role">{barcode}</span>
                        </div>

                        <div className="user-card-secondary">
                          <span>Retail Price: {retailPrice}</span>
                          <span>Wholesale Price: {wholesalePrice}</span>
                          <span>SGST: {SGST}&nbsp; CGST: {CGST}</span>
                          <span>Stock: {stock}</span>
                          <span>Purchase Price: {purchaseAmount}</span>
                        </div>

                        <div className="user-card-actions">
                          <button
                            type="button"
                            className="action-btn edit"
                            onClick={() => handleEdit(item)}
                          >
                            <FontAwesomeIcon icon={faEdit} /> Edit
                          </button>

                            <button
                              type="button"
                              className="action-btn delete"
                              onClick={() => handleDelete(id)}
                            >
                              <FontAwesomeIcon icon={faTrash} /> Delete
                            </button>
                        </div>
                      </div>
                    );
                  })}
                  <Pagination
                    currentPage={currentPage}
                    totalItems={filteredItems.length}
                    itemsPerPage={itemsPerPage}
                    onPageChange={handlePageChange}
                  />
                </div>
			        </>
			      )}
          </div>
          {modal && (
            <div className="modal-overlay">
              <div className="modal-content">
                <h2>Edit Item</h2>
                <form onSubmit={handleEditSubmit}>
                  <table>
                    <tbody>
                      <tr className="login-form-field login-form-field-modal">
                        <td><label htmlFor="edit_name">Item Name *</label></td>
                        <td>
                          <input
                            id="edit_name"
                            type="text"
                            name="name"
                            placeholder="Enter item name"
                            value={editFormData.name}
                            onChange={handleEditChange}
                          />
                        </td>
                      </tr>

                      <tr className="login-form-field login-form-field-modal">
                        <td><label htmlFor="edit_barcode">Barcode *</label></td>
                        <td>
                          <input
                            id="edit_barcode"
                            type="text"
                            name="barcode"
                            placeholder="Enter barcode"
                            value={editFormData.barcode}
                            onChange={handleEditChange}
                          />
                        </td>
                      </tr>

                      <tr className="login-form-field login-form-field-modal">
                        <td><label htmlFor="edit_hsn_code">HSN Code</label></td>
                        <td>
                          <input
                            id="edit_hsn_code"
                            type="text"
                            name="hsn_code"
                            placeholder="Enter HSN Code"
                            value={editFormData.hsn_code}
                            onChange={handleEditChange}
                          />
                        </td>
                      </tr>

                      <tr className="login-form-field login-form-field-modal">
                        <td><label htmlFor="edit_retail_price">Retail Price *</label></td>
                        <td>
                          <input
                            id="edit_retail_price"
                            type="number"
                            step="0.01"
                            min="0"
                            name="retail_price"
                            placeholder="Enter retail price"
                            value={editFormData.retail_price}
                            onChange={handleEditChange}
                            onWheel={(e) => {
                              e.preventDefault();
                              e.currentTarget.blur(); 
                            }}
                          />
                        </td>
                      </tr>

                      <tr className="login-form-field login-form-field-modal">
                        <td><label htmlFor="edit_wholesale_price">Wholesale Price *</label></td>
                        <td>
                          <input
                            id="edit_wholesale_price"
                            type="number"
                            step="0.01"
                            min="0"
                            name="wholesale_price"
                            placeholder="Enter wholesale price"
                            value={editFormData.wholesale_price}
                            onChange={handleEditChange}
                            onWheel={(e) => {
                              e.preventDefault();
                              e.currentTarget.blur(); 
                            }}
                          />
                        </td>
                      </tr>

                      <tr className="login-form-field login-form-field-modal">
                        <td><label htmlFor="edit_stock">Stock *</label></td>
                        <td>
                          <input
                            id="edit_stock"
                            type="number"
                            min="0"
                            name="stock"
                            placeholder="Enter stock quantity"
                            value={editFormData.stock}
                            onChange={handleEditChange}
                            onWheel={(e) => {
                              e.preventDefault();
                              e.currentTarget.blur(); 
                            }}
                          />
                        </td>
                      </tr>

                      <tr className="login-form-field login-form-field-modal">
                        <td><label htmlFor="edit_tax_one">SGST *</label></td>
                        <td>
                          <input
                            id="edit_tax_one"
                            type="number"
                            step="0.01"
                            min="0"
                            name="tax_one"
                            placeholder="Enter SGST"
                            value={editFormData.tax_one}
                            onChange={handleEditChange}
                            onWheel={(e) => {
                              e.preventDefault();
                              e.currentTarget.blur(); 
                            }}
                          />
                        </td>
                      </tr>

                      <tr className="login-form-field login-form-field-modal">
                        <td><label htmlFor="edit_tax_two">CGST *</label></td>
                        <td>
                          <input
                            id="edit_tax_two"
                            type="number"
                            step="0.01"
                            min="0"
                            name="tax_two"
                            placeholder="Enter CGST"
                            value={editFormData.tax_two}
                            onChange={handleEditChange}
                            onWheel={(e) => {
                              e.preventDefault();
                              e.currentTarget.blur(); 
                            }}
                          />
                        </td>
                      </tr>

                      <tr className="login-form-field login-form-field-modal">
                        <td><label htmlFor="edit_purchase_amount">Purchase Amount *</label></td>
                        <td>
                          <input
                            id="edit_purchase_amount"
                            type="number"
                            step="0.01"
                            min="0"
                            name="purchase_amount"
                            placeholder="Enter purchase amount"
                            value={editFormData.purchase_amount}
                            onChange={handleEditChange}
                            onWheel={(e) => {
                              e.preventDefault();
                              e.currentTarget.blur(); 
                            }}
                          />
                        </td>
                      </tr>

                      <tr className="login-form-field login-form-field-modal">
                        <td><label htmlFor="edit_unit">Unit</label></td>
                        <td>
                          <select
                            id="edit_unit"
                            name="unit"
                            value={editFormData.unit}
                            onChange={handleEditChange}
                            style={{width: "96%"}}
                          >
                            <option value="Nos">Nos</option>
                            <option value="mtr">mtr</option>
                            <option value="kg">kg</option>
                            <option value="ltr">ltr</option>
                            <option value="ft">ft</option>
                            <option value="in">in</option>
                            <option value="len">len</option>
                            <option value="box">box</option>
                            <option value="set">set</option>                          
                          </select>
                        </td>
                      </tr>

                      <tr className="login-form-field login-form-field-modal">
                        <td><label>Product Image</label></td>
                        <td>
                          {editFormData.product_image ? (
                            <div className="product-image-container">
                              <img
                                src={typeof editFormData.product_image === "string" 
                                      ? `${API_BASE}${editFormData.product_image}`
                                      : URL.createObjectURL(editFormData.product_image)} 
                                alt="Preview"
                                style={{ width: 100, height: 100, objectFit: "cover" }}
                              />
                              <span>
                                <button
                                  type="button"
                                  onClick={() => setEditFormData((prev) => ({ ...prev, product_image: null }))}
                                >
                                  Remove
                                </button>
                              </span>
                            </div>
                          ) : (
                          <input
                            type="file"
                            accept=".jpg,.jpeg,.png"
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (!file) return;
                              const validTypes = ["image/jpeg", "image/png", "image/jpg"];
                              if (!validTypes.includes(file.type)) {
                                alert("Invalid file type! Only JPG, JPEG, PNG allowed.");
                                return;
                              }
                              setEditFormData((prev) => ({ ...prev, product_image: file }));
                            }}
                          />
                          )}
                      </td>
                      </tr>

                      <tr>
                        <td colSpan={2}>
                          <div className="modal-buttons">
                            <button type="submit" disabled={editSubmitting}>
                              {editSubmitting ? "Updating..." : "Update"}
                            </button>
                            <button type="button" onClick={handleCancelEdit}>
                              Cancel
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ManageItems;